module.exports = __webpack_public_path__ + "static/scale-model-of-before-i-die-wall-austin-tx-in-austin-texas-ce827bc76b2dfa66487e49358a03dd3f.png";